export function readPlaylistSlug(search: string): string | null {
  const value = new URLSearchParams(search).get("playlist")?.trim();
  return value || null;
}

export function buildPlaylistHref(
  pathname: string,
  search: string,
  hash: string,
  slug: string | null,
): string {
  const params = new URLSearchParams(search);
  if (slug) params.set("playlist", slug);
  else params.delete("playlist");
  const query = params.toString();
  return `${pathname}${query ? `?${query}` : ""}${hash}`;
}
